export const questions = [
  {
    title: 'Can I edit the event name later?',
    content: 'The event name is editable only if no tickets have been sold. Once even a single ticket is sold, the event name cannot be edited, as notifications may have already been sent to buyers. If changes are required, please contact the support team.',
  },
  {
    title: 'How can I edit the venue details for a physical event?',
    content: 'Venue details cannot be edited after publishing. If you need to make changes, contact our support team. Buyers who purchased tickets will be notified via email of any updates.',
  },
  {
    title: 'Will my draft event be saved if I leave the flow?',
    content: 'Yes, every step is autosaved as a draft. You can return later to complete the event creation process.',
  },
  {
    title: 'When will I receive my payout for ticket sales?',
    content: 'Payments will be processed within 3 days (T+3) after the event ends or once ticket sales are closed. For any changes to payout details, please contact the support team.',
  },
  {
    title: 'What happens if I don’t add a joining link for an online event?',
    content: 'You won’t be able to skip this step. You need to add a link , however You can also edit the link up to 2 hours before the event starts.',
  },
]

export const venues = [
  {
    name : 'Anna University',
    address_line_1: 'Sardar Patel Road',
    address_line_2: 'Guindy',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name: 'Marina Beach',
    address_line_1: 'Kamarajar Salai',
    address_line_2: 'Triplicane',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Chennai Central Railway Station',
    address_line_1: 'EVR Periyar Salai',
    address_line_2: 'Park Town',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Fort St. George',
    address_line_1: 'Rajaji Salai',
    address_line_2: 'Parry\'s Corner',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Express Avenue Mall',
    address_line_1: 'Whites Road',
    address_line_2: 'Royapettah',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Kapaleeshwarar Temple',
    address_line_1: 'North Mada St',
    address_line_2: 'Mylapore',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Phoenix Marketcity',
    address_line_1: 'Velachery Main Road',
    address_line_2: 'Velachery',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'Government Museum',
    address_line_1: 'Pantheon Road',
    address_line_2: 'Egmore',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'TIDEL Park',
    address_line_1: 'Rajiv Gandhi Salai',
    address_line_2: 'Taramani',
    city: 'Chennai, Tamil Nadu, India',
  },
  {
    name : 'San Thome Basilica',
    address_line_1: 'Santhome High Road',
    address_line_2: 'Mylapore',
    city: 'Chennai, Tamil Nadu, India',
  },
];

export const generateMockEmailId = () => {
  const allowedChars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < 5; i++) {
    const randomIndex = Math.floor(Math.random() * allowedChars.length);
    randomString += allowedChars[randomIndex];
  }

  return `${randomString}@gmail.com`;
};

export const sections = [
    "Modus Operandi",
    "Personal Information",
    "Term of Agreement",
    "Representation & Warranties",
    "Orangisation & Terms",
    "Invoicing & Payment",
    "Set-off",
    "Refund & Cancellation",
    "Rescheduling an Event",
    "Taxes & Compliance",
    "Termination",
    "Product Specifications",
    "Customer Support",
    "Limitations",
    "Indemnification",
    "Force Majeure",
    "Record retention",
    "Procedures & Compliances",
    "Miscellaneous",
    "Notices",
    "Dispute Resolution and Jurisdiction"
  ];

export const vendorAgreement = [
  {
    title: "1. Modus Operandi",
    points: [
     `The Vendor acknowledges and agrees that TMT provides an online platform where the Vendor can independently upload, manage, and sell tickets through a Do-It-Yourself (DIY) model. The Vendor shall be solely responsible for all aspects of the ticket listing process, including but not limited to the creation, description, pricing, and updating of listings. The Vendor understands that TMT will not provide individualised assistance with these tasks but may offer general support materials or guidelines to help the Vendor utilise the platform effectively Accuracy of Information:`,

      `The Vendor warrants that all information provided in connection with ticket listings, including but not limited to event details, seat locations, pricing, and availability, is accurate, truthful, and not misleading. The Vendor shall promptly update any information that becomes inaccurate or outdated. Any inaccuracies or misrepresentations in the ticket listings may result in account suspension, removal of listings, or other penalties as deemed appropriate by TMT.`,

      `The Vendor is expressly prohibited from listing tickets that are counterfeit, fraudulent, or otherwise unlawful. The Vendor shall not engage in any activity that could cause harm to the reputation of TMT or the integrity of the platform. Any prohibited listings may be removed by TMT without notice, and the Vendor may be subject to additional penalties, including account suspension or termination.`,

      `TMT reserves the right, at its sole discretion, to remove any event, promotion, listing, or offer from the Website that it deems inappropriate, misleading, or otherwise unsuitable for its audience. This right includes the ability to disable ticket sales, withdraw listings, or delete promotional materials associated with the listed tickets or event. In cases where an event or listing is removed or restricted from visibility on TMT’s platform, TMT has no obligation to refund or compensate the Vendors for any fees, advertising costs, expenses, or potential revenue losses associated with the removed listing or event. Vendors agree that content eligibility remains under the absolute discretion of TMT.`,
    ],
  },
  {
    title: "2. Collection of Personal Information",
    points: [
     `The Vendor acknowledges, consents, and agrees that, as part of its participation on the Platform, TMT shall collect various types of personal and business information. This may include, but is not limited to, the Vendor's name, business name, address, contact details, identification documents, image, logo, business registration details, bank account information, tax identification numbers, and any other relevant data or materials provided during the registration process or subsequently in connection with listing, promoting, or managing events through the Platform (hereinafter referred to as “Vendor Information”).`,

      `TMT shall retain the Vendor Information for as long as it is required to meet the TMT’s operational, regulatory, and legal obligations. This retention period may extend beyond the completion of any individual event or the termination of the Vendor’s relationship with TMT. The Vendor understands that this retention may be necessary for purposes such as audit compliance, tax reporting, legal proceedings, dispute resolution, historical record-keeping, and operational analysis.`,

      `The Vendor agrees that TMT may, at its sole discretion and without providing prior notice to the Vendor, share or disclose the Vendor Information to any relevant authority or third party as required by law, regulation, or lawful request. This may include, but is not limited to, disclosures made in response to:`,

      `TMT shall have no obligation to inform the Vendor when such disclosures are made and may act in compliance with legal or regulatory obligations without obtaining any further consent from the Vendor. The Vendor waives any right to object to TMT’s collection, retention, or lawful disclosure of Vendor Information, and releases the TMT from any claims, liabilities, or damages arising out of or in connection with such actions.`,

      'Furthermore, the Vendor agrees that it is their responsibility to provide accurate and updated information to the Platform and TMT. In the event of any changes to the Vendor Information, the Vendor shall promptly notify TMT to ensure that all records are kept current and compliant with applicable laws and regulations.',

      'In addition, TMT may use the Vendor Information for internal purposes, including but not limited to marketing, promotions, customer communications, and analytics, provided that such usage is compliant with applicable data protection laws. TMT may also anonymize or aggregate the Vendor Information for purposes of market research or reporting, in which case the Vendor\'s personal identity shall not be disclosed.',
    ],
    subpoints: {
      3: [
        'Requests from law enforcement agencies, government bodies, or regulatory authorities conducting investigations or audits;',
        'Compliance with legal processes such as subpoenas, court orders, or regulatory mandates;',
        'Tax authorities for the purpose of tax reporting or investigation;',
        'Any other lawful demand or obligation imposed upon TMT.'
      ],
    },
  },
  {
    title: "3. Term of Agreement",
    points: [
      "The term of this Agreement shall commence upon its execution and shall remain in effect until the successful organisation and completion of the event.",
    ],
  },
  {
    title: "4. Representation and Warranties",
    points: [
      `Competence to Contract - The Parties affirm that they are duly authorised under Indian law and have full power and authority to execute and adhere to this Agreement, with all necessary actions completed to validate its execution and fulfilment.`,

      `No Breach: The execution, delivery, adherence to, and breach of this Agreement do not conflict with any applicable laws, rules, or regulations, nor do they result in a breach or default under any contract, commitment, or agreement to which either Party is bound.`,

      `Liabilities:Each Party affirms that they have no liabilities, debts, or obligations, whether accrued, absolute, or contingent, that could negatively impact TMT or hinder the completion of the transactions under this Agreement. Both Parties agree that, unless explicitly stated otherwise, TMT will not assume or be liable for any responsibilities or liabilities of the Vendor arising from prior contractual breaches, whether involving other parties, third parties, or otherwise.`,

      `Parties to not be Prejudicial to Each Other’s Interests - The Parties agree to refrain from any actions that may harm each other’s interests in the normal course of operations and commit to exercising due care and diligence to protect the reputation of the other Party and their respective Affiliates.\n
      The Parties agree to refrain from any actions that may harm each other’s interests in the normal course of operations and commit to exercising due care and diligence to protect the reputation of the other Party and their respective Affiliates.`,

      `Vendors are solely responsible for ensuring the accuracy of all event-related details provided to TMT, including but not limited to entry times, ticket prices, seating arrangements, venue policies, and any other information that may influence Users expectations and decisions. TMT serves solely as a platform for event promotion and ticketing and will not assume liability for any losses, including revenue loss, arising from inaccuracies, omissions, or errors in the information supplied by the Vendor. Any resulting claims, complaints, or refunds that may arise due to such errors shall remain the exclusive responsibility of the Vendor.\n\n
      The Vendor hereby warrants to TMT as follows:`,

      `Service Conduct - The Vendor shall diligently invest their best efforts, time, and energy in delivering the Services to TMT as outlined in this Agreement, adhering to the applicable industry and professional standards.`,

      `Professional Skills - Vendor guarantees that they presently possess and will continuously maintain all the requisite licences, skills, experience, and forms essential for the execution of the Services in accordance with the terms and conditions delineated in this Agreement.`,

      `Conflict of Interest - The Vendor affirms that they have no business, professional, personal, or other interests that conflict with their obligations under this Agreement. The Vendor shall not, directly or indirectly, engage in any activities, hold any interests, or provide services to any person involved in activities that conflict with or compete with the interests of TMT.`,

      `Lawful Conduct - The Vendor shall, at their own expense, comply with all applicable laws, ordinances, rules, and regulations during the performance of Services, including tax, social welfare, worker's compensation, insurance, employer liability, and minimum wage requirements. The Vendor is responsible for fulfilling all reporting obligations and settling all taxes, fees, and charges, without reimbursement from TMT. The Vendor shall indemnify TMT against any liabilities or penalties arising from their failure to comply with such laws, orders, rules, or regulations.`,

      `Vendor Compliance with Safety, Security, and Regulatory
      Protocols`,

      `TMT represents and warrants to the Vendor as follows:
      Timely Payment - TMT represents and warrants to the Vendor that the
      Services rendered under this Agreement will be duly compensated as
      per the terms of this Agreement with no undue or unwarranted delay.`,

      `Adequate Resources - TMT shall provide adequate direction, advice,
      guidance, and all resources which it deems as reasonably required for
      the successful execution of the Vendor’s Services, at no further cost or
      prejudice to the Vendor.`,

      `Lawful Conduct - TMT shall, at its own expense, comply with all
      applicable laws, ordinances, rules, and regulations during the
      performance of Services, including tax, social welfare, worker's
      compensation, unemployment insurance, liability, and minimum wage
      requirements. TMT shall file all necessary reports in its name and pay
      all taxes, fees, and charges required by laws, rules, regulations, and
      orders.`,

      `Third Parties - The making of this Agreement and the Vendor’s
      performance of all its obligations hereunder is not prohibited by or in
      conflict with any agreement between the TMT and any third party.
      OTHER OBLIGATIONS`,

      `The Vendor may collaborate with TMT on joint marketing initiatives to
      enhance the visibility of the event and the Platform. Any such
      collaboration will be subject to separate agreements and terms. Vendor
      acknowledges and agrees that upon usage of the TMT’s platform for
      the Services as provided and enumerated herein; TMT shall have the
      inclusive right to market, promote, advertise, announce, replicate or
      any other marketing initiatives that may deem necessary by TMT.`,

      `The Vendor is required to seek the Platform’s approval for any
      promotional materials that include the Platform’s name or branding
      before distribution.`,

      `The Vendor agrees that if they are selling tickets for an event both
      offline or on any other platform in addition to listing them on this
      Platform, they must promptly and accurately update the available ticket
      quantity on our Platform to reflect real-time inventory. Failure to
      update the quantity in a timely manner may result in discrepancies,
      including the risk of overselling or misrepresentation of availability.`,

      `The Vendor acknowledges and agrees that the Platform shall not be
      held responsible or liable for any such discrepancies arising from the
      Vendor’s failure to update the ticket quantities. Any issues resulting
      from overselling, buyer disputes, or non-fulfillment of ticket purchases
      due to unavailability shall solely be the responsibility of the Vendor.
      The Vendor further agrees to indemnify the Platform against any
      claims, damages, losses, or penalties arising from the failure to update
      inventory.`,

      `In the event of any missed or unfulfilled transaction due to such a
      failure, the Vendor shall bear full responsibility for compensating
      affected buyers, resolving disputes, and covering any additional costs
      or liabilities, including refunds, penalties, or reputational damage
      caused to the Platform. The Platform reserves the right to take
      necessary measures, including but not limited to account suspension or
      termination, in cases of repeated non-compliance with this obligation.`
    ],
    subpoints : {
      10: [
        `The Vendor hereby acknowledges and agrees to comply with
        all relevant laws, regulations, industry standards, and
        event-specific policies related to the safe organisation,
        execution, and management of the event. This includes, but is
        not limited to, compliance with local, state, and federal safety
        regulations, fire and emergency protocols, security
        requirements, and any specific safety standards imposed by the
        event venue or governing bodies`,

        `The Vendor shall be fully responsible for ensuring the
        implementation, enforcement, and monitoring of all appropriate
        safety and security protocols throughout the event. The
        following key responsibilities, among others, shall be strictly
        adhered to by the Vendor:`,

        `Health and Safety Compliance: The Vendor must comply with
        all applicable public health and safety regulations, ensuring that
        the event is conducted in a manner that safeguards the
        well-being of attendees, event staff, and third parties. This
        includes providing sufficient health facilities, first aid stations,
        and necessary medical staff at the venue, as well as adhering to
        any health advisory measures, such as sanitation protocols,
        health screenings, or social distancing requirements (where
        applicable).`,

        `Fire Safety and Evacuation Procedures: The Vendor is
        responsible for ensuring that the venue is equipped with
        adequate fire safety measures, including fire extinguishers,
        smoke detectors, clear signage of emergency exits, and proper
        training of event staff in fire safety procedures. The Vendor
        shall also develop and maintain an evacuation plan in
        compliance with local fire codes, ensuring that the venue can
        be evacuated swiftly and safely in the event of an emergency.`,

        `Security Management and Crowd Control: The Vendor shall
        ensure the safety and security of all attendees, buyers, event
        staff, and third parties by implementing appropriate security
        measures, including but not limited to:`,

        `Employing qualified and licensed security personnel for the
        event, where necessary.`,

        `Conducting security screenings and access control at entry
        points to prevent unauthorised access, weapons, or dangerous
        materials from entering the venue.`,

        `Managing and controlling the crowd to avoid overcrowding,
        stampedes, or any other hazardous situations that may
        jeopardise the safety of attendees.`,

        `Monitoring and addressing any suspicious or inappropriate
        behaviour that could compromise the safety and security of the
        event.`,

        `Emergency Preparedness and Response: The Vendor shall
        establish and communicate a comprehensive emergency
        response plan, detailing procedures for handling various
        emergency situations such as medical emergencies, natural
        disasters, security threats, or technical failures. This plan must
        include specific roles and responsibilities for event staff, clear
        communication protocols, and designated assembly points in
        case of evacuation.`,

        `Venue Capacity and Safety Limits: The Vendor shall ensure
        that the number of attendees does not exceed the venue’s
        maximum capacity as established by law or venue regulations,
        and shall implement necessary measures to monitor and control
        attendee numbers in real-time. The Vendor is also responsible
        for ensuring that all structures, staging, seating, and equipment
        used at the event comply with safety standards and do not pose
        a risk to attendees.`,

        `Insurance and Risk Management: The Vendor is required to
        obtain and maintain appropriate insurance coverage, including
        but not limited to general liability, public liability, and event
        cancellation insurance, to cover potential risks or liabilities
        arising from the event. Proof of such insurance must be
        provided to the platform upon request.`,

        `Third-Party Vendor Compliance: If the Vendor engages
        third-party service providers (e.g., catering, equipment rental,
        transportation), the Vendor is responsible for ensuring that such
        third parties also comply with all relevant safety protocols and
        standards. The Vendor shall conduct due diligence to verify that
        these third parties are adequately licensed, insured, and capable
        of meeting the safety and security requirements of the event.`,

        `The Vendor acknowledges that any failure to comply with these
        safety and security protocols, or any negligence in enforcing
        such protocols, shall be solely and entirely attributable to the
        Vendor. The Platform shall not be held liable or responsible for
        any injuries, damages, losses, or harm caused to attendees,
        buyers, third parties, or event staff due to the Vendor’s
        non-compliance, negligence, or failure to enforce safety
        measures.`,

        `Furthermore, in the event of any incident or claim arising from
        the Vendor’s failure to adhere to the aforementioned safety
        protocols, the Vendor agrees to fully indemnify, defend, and
        hold harmless the Platform, its affiliates, officers, and
        employees from any and all claims, damages, legal costs,
        penalties, or other liabilities, including but not limited to:`,

        `Compensation for personal injuries, property damage, or
        wrongful death.`,

        `Costs associated with litigation, legal defence, and settlement
        of claims.`,

        `Fines, penalties, or other regulatory sanctions imposed by
        authorities for non-compliance.`,

        `The Vendor further agrees that the Platform is not responsible
        for any expenses related to rectifying safety deficiencies,
        emergency response efforts, or any other costs arising from the
        Vendor’s failure to implement or maintain adequate safety and
        security measures.`,
      ]
    },
  },
  {
    title: "5. ORGANISATION AND TERMS",
    points: [
      "TMT retains the exclusive right, at its sole discretion, to introduce or facilitate the availability of exclusive deals or discounts on the Platform in the future. This potential feature is not guaranteed and shall be implemented based on TMT’s assessment of market conditions and business strategy.",

      `Should TMT decide to enable the option for Vendors to offer exclusive deals or discounts, it will provide the Vendor with comprehensive details regarding the promotional opportunity. Such details will include, but are not limited to: `,

      `The Vendor agrees to carefully review all terms, conditions, and guidelines provided by TMT concerning any exclusive deals or discounts; `,

      `The Vendor agrees to cooperate fully with TMT during the implementation process of any exclusive deals or discounts. This cooperation may include: `,
    ],
    subpoints: {
      2: [
        `Eligibility Criteria: Specific qualifications or conditions that the Vendor must meet to participate in the promotional offer. `,
        `Terms and Conditions: The full scope of the promotion, including its duration, any financial parameters, and other relevant conditions. `,
        `Limitations and Requirements: Any additional requirements or limitations that apply to the exclusive deals or discounts, including any restrictions on the scope or geographic availability of the offers.`,
      ],
      3: [
        `The Vendor must adhere to these terms and conditions and fulfil all obligations associated with the promotional offers. This compliance may involve:\n Execution of Additional Agreements: Entering into supplementary agreements or amending the existing Agreement as required by TMT. \n Operational Adjustments: Making necessary adjustments to the Vendor’s operations or offerings to accommodate the promotional terms.`
      ],
      4: [
        `Operational Coordination: Adjusting the Vendor’s promotional strategies and logistics in alignment with TMT’s guidelines. `,
        `Additional Obligations: Fulfilling any further obligations that arise as a result of the introduction of exclusive deals or discounts, as specified by TMT.`,
      ],
    },
  },
  {
    title: "6. INVOICING AND PAYMENT",
    points: [
      `TMT will charge a flat commission fee which shall be determined by TMT under their sole and absolute discretion which may be communicated by TMT to the Vendor out of the total gross revenue generated from the sale of tickets for each event organised by the Vendors on the Platform. The fee is calculated based on the total amount of ticket sales for the event, excluding any applicable taxes or other charges that may be imposed by local regulations. The commission fee will be deducted from the total revenue collected from ticket sales before any payments are disbursed to the Vendors. The net amount, after deducting the fee, will be transferred to the Vendors. TMT will provide a detailed fee statement to the Vendors, outlining the total revenue, the commission fee deducted, and the net amount payable. This statement will be issued along with the payment for the event.`,

      `TMT will determine a flat fee to be charged from the buyers, it is acknowledged and agreed that the same shall be communicated through the website (or any changes thereto). This fee is applied to the total ticket price at the time of purchase. The fee will be included in the final transaction amount and will be clearly displayed during the checkout process. Buyers will be informed of the total amount payable, including the fee, before completing the purchase. The fee will be collected at the time of the transaction and will be processed alongside the ticket purchase amount. TMT will handle all payment processing and fee collection in accordance with its standard procedures.`,

      `Payments to Vendor will be made on a scheduled basis as enumerated under Annexure A of this Agreement, with the commission fee deducted prior to the payment. TMT will ensure that payments are processed promptly and in accordance with the terms outlined in this Agreement.`,

      `Fees collected from buyers will be automatically processed during the ticket purchase process. TMT will manage and account for all fees collected from buyers as part of its financial operations.`,

      `TMT reserves the right to modify the commission and fee structure, including changes to the fee percentages, at its sole discretion. Any such adjustments will be updated on the website. It is further understood that TMT shall be under no obligation to communicate it directly to the Buyers and the Vendors`,

      `The Vendor acknowledges and agrees that all transactions processed through the platform may subject any bank transaction fees. Any associated bank transaction fees will be deducted from the total payment amount. These fees are non-refundable under any circumstances, including event cancellations or rescheduling. The Vendor acknowledges that such deductions are final, and no reimbursements will be provided for any bank fees incurred. The Vendor is not entitled to dispute or challenge the deduction of bank transaction fees once a transaction has been completed through the platform.
      CYCLES`,

      `TMT shall remit payment to the Vendor for tickets sold through the Platform only after the event for which the tickets were issued has been fully completed. The term "completion of the event" is defined as the conclusion of the event's activities and any post-event obligations related to the ticket sales. Payments to the Vendor will be processed and disbursed within a period of seven (7) to twelve (12) business working days following the official completion date of the event.`,

      `Payments will be made using the payment method chosen at TMT's sole discretion, as acknowledged during account setup or as provided by the Vendor under TMT's terms and conditions. The Vendor is responsible for maintaining accurate and up-to-date payment information to ensure successful transaction processing. `,

      `The Vendor must notify TMT in writing of any disputes or discrepancies related to payments within ten (10) business days of receiving the payment confirmation, specifying the nature of the issue and relevant details. Failure to provide such notice within this period will be deemed as full and final confirmation of the payment.`,
      
      `TMT will investigate and resolve any reported discrepancies or disputes in a timely manner. The resolution process will involve reviewing the transaction details and addressing any issues to ensure accurate and fair payment; TMT reserves the right to amend these payment terms, including the processing timeline and payment methods under TMT’s sole discretion; The Vendor agrees to comply with all terms related to payment as stipulated in this Agreement and any future amendments or additional agreements that may be introduced.`
    ],
  },
  {
    title: "7. SET-OFF",
    points: [
      "TMT may set off any amount owing at any time to the Vendor or any of its affiliates against any amount payable at any time by TMT under these terms as enumerated under this Agreement.",
    ],
  },
  {
    title: "8. REFUND AND CANCELLATION",
    points: [
      `Vendor acknowledges and agrees that refunds shall be issued to buyers in cases where the event has been cancelled by the Vendors and under no obligation shall TMT be obligated to refund any payment. It is further understood that in case TMT refunds/pays/ any amount vis-a-vis cancellation of an event by the Vendor, the Vendor shall indemnify the TMT in full.`,

      `The total ticket purchase amount, including any applicable fees charged by TMT, shall be refunded to the buyer. If an event is cancelled by the Vendor, Vendor must promptly notify TMT and provide all relevant details of the cancellation. TMT will process refunds to buyers based on the information provided by the Vendor..`,

      `In the event of an organiser-initiated cancellation, TMT reserves the right to charge a cancellation fee to the Vendor. This fee will be a percentage of the total ticket sales amount and is intended to cover administrative costs and potential losses incurred by TMT. The specific percentage of the cancellation fee will be determined by TMT and communicated to the Vendor prior to the event's cancellation. The cancellation fee will be deducted from any amounts due to the Vendor, and the net amount will be used to process refunds to buyers. TMT will provide a detailed statement outlining the cancellation fee and the net amount refunded.`,

      `In the event of a chargeback initiated by a buyer’s bank or payment provider, TMT will follow its standard chargeback procedures. TMT will review the chargeback request and take appropriate action based on the findings. If the chargeback leads to a reversal of funds previously paid to the Vendor, TMT may recover the amount from the Vendor’s future payments or apply other necessary remedies.`,

      `TMT will maintain and update its refund, chargeback, and cancellation policies as necessary. These policies will be made available on the Platform and will be communicated to both Vendor and buyers.`,
    ],
  },
  {
    title: "9. RESCHEDULING OF EVENT",
    points: [
     `In the event that an event for which tickets have been sold on the platform is rescheduled for any reason, TMT shall not be held liable for any losses, costs, or damages incurred by the Vendor, ticket purchasers, or any third parties. The responsibility for notifying ticket holders of the rescheduled date, time, or venue rests solely with the Vendor.`,
      `The Vendor shall ensure timely communication of any rescheduling to both TMT and ticket purchasers within a reasonable time frame. No additional charges shall be imposed by the Vendor for rescheduling. However, if any ticket holder requests a refund due to their inability to attend the rescheduled event, the Vendor agrees to repay TMT for any fees or charges incurred in facilitating the original ticket sale or the refund process.`,
      `Furthermore, the Vendor shall indemnify and hold TMT harmless from any claims, expenses, or liabilities arising out of or related to the failure to notify of the rescheduling or the handling of refunds. TMT’s role in the rescheduling process shall be limited to facilitating the necessary changes on the platform, without assuming any liability for disputes or cancellations resulting from the rescheduled event.`,
    ],
  },
  {
    title: "10. TAXES & COMPLIANCE",
    points: [
      `The Vendor agrees that the ticket price listed on the platform shall be presented as the final price payable by the buyer, inclusive of all applicable taxes, including but not limited to Goods and Services Tax (GST), state and local taxes, and any other statutory levies. The Vendor shall ensure that all required taxes are included in the listed price at the time of posting the ticket on the platform. Under no circumstances may the Vendor collect GST or any other taxes separately from the listed ticket price, nor shall the Vendor charge any additional amounts related to taxation after the transaction is completed.`,

      `The Vendor is responsible for the accurate calculation and inclusion of taxes in compliance with all applicable tax regulations, and any failure to comply with such requirements shall be the sole responsibility of the Vendor. The platform will not facilitate or recognize any separate tax collection beyond the final ticket price displayed to the buyer. In the event of any tax audits or disputes arising from the Vendor’s failure to include taxes within the ticket price, the Vendor shall be solely liable and responsible for resolving such issues without recourse to the platform.`,

      `The Vendor is solely responsible for all tax obligations arising from ticket sales through the Platform, including sales tax, VAT, GST, and any other applicable taxes. The Vendor agrees to comply with relevant tax laws and ensure that all taxes are properly calculated, reported, and remitted to the appropriate authorities. TMT will not be liable for any tax implications, liabilities, penalties, or interest resulting from the Vendor’s failure to comply with tax laws and will not withhold any taxes from payments made to the Vendor. The Vendor is responsible for managing their own tax obligations and ensuring timely payment in accordance with applicable laws.`,

      `Payments due under this Agreement shall be made in Indian Rupees, as per the prevailing terms and conditions as enumerated under this Agreement.`,

    ],
  },
  {
    title: "11. TERMINATION",
    points: [
      `Voluntary Termination: TMT reserves the right to terminate or
suspend your access to its services, platform, or website at any time,
with or without notice, for any reason, including but not limited to a
breach of these Terms and Conditions of this Agreement, violation of
applicable laws, or misuse of the services. Upon such termination, all
rights granted to you under this Agreement will immediately cease.
Any outstanding obligations, including but not limited to payment
liabilities or compliance with ongoing contractual duties, shall survive
the termination. The Company shall not be liable for any claims,
damages, or losses arising from such termination.`,
`Termination by the Vendor: The Vendor may terminate this Agreement
by providing [5] days’ written notice to TMT. Such termination will
not affect the Vendor’s responsibility for any payments due or
obligations incurred prior to the termination date.`,
`Termination for the Cause: Terminating Party may, on account of
any material breach of the respective duty, obligation of the Terminated
Party and towards the Terminating Party; or has acted fraudulently,
with wilful misconduct, moral turpitude, behavioural misconduct,
dishonesty, gross negligence, or abuse of authority including but not
limited to leaking of confidential information, provoking or abetting to
any unlawful operation as against the Terminating Party; or
deliberately or not; or has caused intentional material damage to the
Terminating Party or has attempted to do any of the above.
(Hereinafter referred to as “Cause”) terminate the services of the
Terminated Party immediately, irrespective of the time period of the
service period.`,
`In addition to the termination of the Agreement the provisions of the
Agreement shall stand null and void. Notwithstanding the above stated
clause, Clause 2, 4, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19 shall
survive the termination or expiration of this Agreement.`,
`Consequences of Termination`,

    ],
    subpoints: {
      5: [
        `Cessation of Services: Upon termination of this Agreement, the
        Vendor shall immediately cease all use of the Platform,
        including the listing, marketing, and sale of tickets.`,

        `Settlement of Accounts: TMT shall settle any outstanding
        payments owed to the Vendor for tickets sold prior to the
        termination date, subject to the terms of this Agreement. The
        Vendor shall also settle any outstanding fees or charges owed to
        TMT.`,

        `Return of Proprietary Information: The Vendor shall promptly
        return or destroy all proprietary and confidential information
        belonging to TMT that is in the Vendor’s possession, including
        any access credentials, marketing materials, or data provided by
        TMT.`,

        `Any unsold tickets remaining at the time of termination shall
        remain unsold, as TMT acts solely as an agent facilitating
        transactions and does not purchase tickets from Vendor. The
        Vendor shall retain responsibility for any unsold tickets and
        their subsequent handling or disposition.`,

        `Upon termination of this Agreement, for any reason, both
        Parties agree to promptly return or destroy, as directed by the
        owning Party, all proprietary information, documents,
        materials, and data belonging to the other Party, whether in
        physical or electronic form, that were provided or created in
        connection with this Agreement.`,

        `Additionally, each Party shall ensure that all outstanding dues,
        payments, or financial obligations owed to the other Party
        under the terms of this Agreement are settled in full within 10
        days from the date of termination.`,
      ]
    }
  },
  {
    title: "12. PRODUCT SPECIFICATIONS AND IDENTIFICATION",
    points: [
      `The Vendor is fully responsible for ensuring that all tickets sold
      through the Platform, whether physical or e-tickets, are valid, genuine,
      and fully transferable. The Vendor guarantees that each ticket
      corresponds to legitimate entry for the intended event and complies
      with event requirements, including format and security features.`,

      `The Vendor shall comply with all applicable ticket transfer policies
      established by event organisers, the Platform, or relevant legal
      authorities. If ticket transfers are permitted, the Vendor must facilitate
      these transfers in compliance with applicable policies, ensuring that
      transferred tickets remain valid and usable.`,

      `The Vendor acknowledges that failure to provide valid tickets, deliver
      them timely, or comply with transfer policies may result in significant
      harm and liabilities. In such cases, the Vendor agrees to indemnify
      TMT and its affiliates against any claims, damages, or expenses arising
      from non-compliance.`,

      `Additionally, the Vendor agrees to implement stringent quality
      assurance measures to monitor ticket validity and compliance,
      including regular audits and prompt responses to discrepancies
      identified by buyers or the Platform.`,
    ],
  },
  {
    title: "13. COMPLIANCE WITH LAWS AND CUSTOMER SUPPORT",
    points: [
     `The Vendor shall comply with all applicable national, state, and local
      laws and regulations governing event organisation, ticket listing, and
      the performance of Services under this Agreement. The Vendor is
      responsible for providing customer support for inquiries related to their
      tickets on the Platform, including addressing questions and managing
      concerns from buyers.`,

      `TMT will forward all relevant customer support inquiries to the
      Vendor’s designated contact person or support team, who must respond
      within twenty-four (24) hours. For complex issues requiring more
      time, the Vendor should acknowledge receipt and provide an estimated
      resolution timeframe, not exceeding forty-eight (48) hours.`,

      `The Vendor must maintain up-to-date contact information for customer
      support and ensure availability during regular business hours.
      Additionally, the Vendor is required to keep records of all customer
      support interactions and provide periodic reports on response times and
      issue resolutions to TMT upon request.`,
    ]
  },
  {
    title: "14. LIMITATION OF LIABILITY",
    points: [
      `Neither Party shall be liable to the other for any special, indirect,
      consequential, or incidental damages, including loss of business profits
      or information, arising from omissions or failures related to this
      Agreement. TMT shall not be liable for any misbehaviour, negligence,
      or acts of the Vendor or its agents, nor for any unauthorised actions
      taken by individuals employed by the Vendor during the Agreement's
      term.`,

      `TMT shall not be responsible for the actions, errors, or omissions of
      any third-party services engaged by the Vendor; any disputes arising
      from such actions shall be solely between the Vendor and the third
      party. TMT makes no representations regarding the availability or
      performance of the Platform and will not be liable for indirect or
      consequential damages resulting from event cancellations or
      postponements.`,

      `TMT shall not be liable for any cancellations, losses, expenses, or
      damages arising from the cancellation of any event for which tickets
      have been sold on the platform. TMT assumes no responsibility for any
      claims, refunds, or disputes related to such cancellations, and the
      Vendor agrees that TMT’s liability in such cases is expressly excluded.`,

      `In the event of a cancellation, the Vendor shall bear full responsibility
      for reimbursing any losses, expenses, costs, or damages incurred by
      TMT, ticket purchasers, or any third parties arising out of or related to
      such cancellation. The Vendor shall indemnify and hold TMT harmless
      from any claims or liabilities resulting from their failure to notify TMT
      of the event’s cancellation.`,

      `The Vendor acknowledges that the Platform may experience
      interruptions or technical issues, and TMT is not liable for damages
      resulting from such occurrences. Use of the Platform is at the Vendor's
      own risk.`
    ],
  },
  {
    title: "15. INDEMNIFICATION",
    points: [
      `The Vendor agrees to indemnify and hold harmless TMT against any
      claims, damages, or losses arising from the cancellation or
      postponement of an event or resultant of any breach of this Agreement
      by the Vendor. This includes, but is not limited to, costs associated
      with issuing refunds, administrative fees, and any other related
      expenses.`,

      `The Vendor agrees to indemnify, defend, and hold harmless TMT, its
      affiliates, directors, officers, employees, agents, and representatives
      (collectively, the "Indemnified Parties") from and against any and all
      claims, demands, actions, suits, proceedings, liabilities, damages,
      losses, costs, and expenses (including, but not limited to, reasonable
      attorneys' fees and legal costs) arising out of or in connection with:`,
    ],
    subpoints :{
      2 : [
        `Any breach or alleged breach by the Vendor of any
        representation, warranty, covenant, or obligation under this
        Agreement;`,

        `The Vendor’s violation of any applicable laws, regulations, or
        third-party rights, including intellectual property rights, in
        connection with the performance of its obligations under this
        Agreement;`,

        `Any claim arising from the sale, delivery, or provision of
        tickets or related services by the Vendor, including but not
        limited to claims of fraud, misrepresentation, or defective or
        invalid tickets;`,

        `Any act or omission by the Vendor or its employees, agents, or
        subcontractors that results in injury to persons or damage to
        property`,
      ]
    }
  },
  {
    title: "16. FORCE MAJEURE",
    points: [
      `Delay in performance or non-performance of any obligation of TMT
      or Vendor under these Terms and Conditions shall be excused to the
      extent such failure or non-performance is caused by Force Majeure.
      "Force Majeure" means any cause preventing performance of an
      obligation under these Terms and Conditions which is beyond the
      reasonable control of the Vendor or TMT but would not constitute
      commercial hardships or in lieu of commercial hardships, and which,
      by the exercise of due diligence, could not be overcome, including
      without limitation, fire, flood, sabotage, shipwreck, war (whether
      declared or not), terrorism, embargo, explosion, strike or other labour
      trouble, accident, riot, pandemic, epidemic, acts of a governmental
      authority, and acts of God.`,

      `Party affected by Force Majeure shall:`,

      `In the event of a force majeure situation that leads to the cancellation
      of an event, the following policies will apply;`,

      `The Vendor must promptly notify the Platform in writing of any force
      majeure event that affects or may affect the event. The notification
      should include details of the event, its impact on the event, and any
      relevant documentation supporting the claim of force majeure. The
      Platform reserves the right to verify the force majeure event and assess
      its impact on the event. The Platform may request additional
      documentation or information from the Vendor as needed.`
    ],
    subpoints : {
      2 : [
        `promptly provide notice to the other Party, explaining the full
        particulars and the expected duration of the Force Majeure and1`,

        `use its best efforts to remedy the interruption or delay if it is
        reasonably capable of being remedied. In the event of Force
        Majeure. If a Force Majeure extends for more than 3 (Three)
        days, these Terms and Conditions may be terminated upon
        written notice by the Party not declaring Force Majeure without
        any liability on its part.`,
      ],
      3 : [
        `The Platform will process refunds for all tickets purchased for
        the affected event.`,
        `The refund will cover the full ticket price paid by the buyers,
        including any applicable fees charged by the Platform.`,
        `TMT shall not be liable for any costs related to the cancellation
        of the event.`,
      ]
    }
  },
  {
    title: '17. RECORD RETENTION',
    points: [
      `Vendor will maintain complete and accurate records of the Services
      performed under this Agreement for a period of 7 [Seven] years after
      the completion of these Services. Records relating to the performance
      of this Agreement shall be made available to TMT upon reasonable
      notice.`
    ]
  },
  {
    title: '18. PROCEDURES AND COMPLIANCES',
    points: [
      `The Vendor acknowledges and agrees that the Platform does not
      purchase tickets from the Vendors; it solely acts as an intermediary to
      facilitate transactions between Vendor and buyers. Therefore, the
      Platform does not assume any responsibility for unsold tickets.`,

      `Termination of Agreement: Upon termination of this Agreement, the
      Platform will cease all activities related to the listing and sale of tickets
      for the event as provided by the Vendor. Any unsold tickets that remain
      on the Platform at the time of termination will remain unsold and will
      not be purchased or otherwise handled by the Platform.`,

      `Responsibility for Unsold Tickets: The Vendor remains solely
      responsible for managing the unsold tickets. The Platform will not be
      liable for any unsold tickets or related financial implications following
      the termination of the Agreement. The Vendor acknowledges that they
      will bear all risks and costs associated with unsold tickets.`,

      `Either party must provide advance written notice of termination as
      specified in the Agreement. Upon receipt of such notice, the Platform
      will stop accepting new ticket listings and will take appropriate
      measures to inform buyers and manage existing ticket sales.`,

      `Post-Termination Procedures`,

      `Any outstanding payments or financial settlements due to the Vendor
      will be processed in accordance with the terms specified in the
      Agreement, up to the effective date of termination.`
    ],
    subpoints : {
      5 : [
        `The Platform will promptly remove all event listings and
        associated tickets from its system upon termination. This
        includes removing all references to the event from the Platform
        and discontinuing all related services.`,

        `The Platform will not be responsible for transferring or
        managing ticket information after termination. The Vendor
        should make arrangements to manage or dispose of unsold
        tickets as deemed appropriate.`
      ]
    }
  },
  {
    title: '19. MISCELLANEOUS',
    points: [
      `Interpretation: This Agreement shall be construed and interpreted in
      accordance with the internal laws of India.`,

      `Supremalex: This Agreement supersedes and is in lieu of any and all
      other arrangements between TMT and the Vendor.`,

      `This Agreement shall be binding upon and inure to the benefit of the
      Parties hereto and their respective successors and permitted assigns. In
      the event of any dispute, neither Parties interpretation of the terms of
      this Agreement shall be given deference.`,

      `This Agreement is the result of negotiations between and has been
      reviewed by each of the Parties hereto and their respective counsel, if
      any; accordingly, this Agreement shall be deemed to be the product of
      all of the Parties hereto, and no ambiguity shall be construed in favour
      of or against any one of the Parties hereto.`,

      `The Agreement shall be executed in any number of counterparts, each
      of which shall be an original, but all of which together shall constitute
      one instrument.`,

      `The Vendor may not assign or subcontract its obligations under this
      Agreement without prior written consent from TMT; any unauthorised
      assignment or subcontract shall be void. The Vendor remains jointly
      and severally liable for breaches by any assignee or subcontractor.`,

      `If any provision of this Agreement is deemed unenforceable, the
      Agreement shall be interpreted accordingly. The unenforceable
      provision will be considered inoperative to that extent, while the
      remainder of the Agreement will remain in full force. If a provision
      can be made enforceable by limitation, it shall be enforced to the
      maximum extent permissible by law.`,

      `The failure of either Party to enforce any provision of this Agreement
      or to exercise any right shall not be construed as a waiver of that
      provision in the future. Such provision shall remain in full force and
      effect. Any waiver or modification of this Agreement must be made in
      writing and signed by both Parties.`,

      `In performing Services under this Agreement, the Vendor is an
      independent contractor, and its personnel shall not act as agents or
      employees of TMT.`  
    ]
  },
  {
    title: '20. NOTICES',
    points: [
      `Any or all notices to be given by the Parties hereto to each other under this Agreement shall only be in writing and shall be transmitted by registered post, or by courier service, or by personal delivery, as elected by the Party giving such notice, at the addresses as mentioned below: 
      Party’s Name: TMT
      Registered Office: INNOV8 SKCL TECH SQUARE NO:14, 2ND FLOOR, SIDCO T.V.K INDUSTRIAL ESTATE GUINDY PARK, GUINDY, CHENNAI-600032
      Email: rescue@takemytickets.co.in`,
    ]
  },
  {
    title: '21. DISPUTE RESOLUTION AND JURISDICTION',
    points: [
      `Any disputes arising out of or in connection with this Agreement shall be resolved through arbitration conducted in accordance with the Arbitration and Conciliation Act, 1996, as amended from time to time. The seat and venue of arbitration shall be Chennai, Tamil Nadu, India, and the proceedings shall be conducted in English. Subject to the foregoing, the courts in Chennai, Tamil Nadu, shall have exclusive jurisdiction.`,
    ]
  }
];